import { render, staticRenderFns } from "./realname.vue?vue&type=template&id=7e159e5a&scoped=true&"
import script from "./realname.vue?vue&type=script&lang=js&"
export * from "./realname.vue?vue&type=script&lang=js&"
import style0 from "./realname.vue?vue&type=style&index=0&id=7e159e5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e159e5a",
  null
  
)

export default component.exports